module.exports = __webpack_public_path__ + "media/images/icons/country_flags/jp-d288d548026f04523965869470b09fc5.svg";